export enum RoomBulkUpdateAction {
  EnableAugi = 'ENABLE_AUGI',
  DisableAugi = 'DISABLE_AUGI',
  // Consent = 'CONSENT',
  // RevokeConsent = 'REVOKE_CONSENT',
  // UpdateBillingCode = 'UPDATE_BILLING_CODE',
}
